import { render, staticRenderFns } from "./BuildingAndRecipe.vue?vue&type=template&id=2c975162&"
import script from "./BuildingAndRecipe.vue?vue&type=script&lang=ts&"
export * from "./BuildingAndRecipe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports